// extracted by mini-css-extract-plugin
module.exports = {"longPress":"LongPress_longPress__1DcgB","icon":"LongPress_icon__uSdxg","deleteHint":"LongPress_deleteHint__AOmAi"};